import { Breadcrumbs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import React from 'react';
import withBreadcrumbs from 'react-router-breadcrumbs-hoc';
import { NavLink } from 'react-router-dom';
import BreadcrumbBarProps from './BreadcrumbBarProps';

const useStyles = makeStyles((theme) => ({
    breadcrumbs: {
        paddingBottom: 15
    },
    navigator: {
        color: '#ffffff'
    }
}));

export default function BreadcrumbBar(props: BreadcrumbBarProps) {

    const classes = useStyles();

    const BreadcrumbLinks = withBreadcrumbs(props.routes)(({ breadcrumbs }) => (
        <Breadcrumbs className={classes.breadcrumbs} separator={<NavigateNextIcon fontSize="small" className={classes.navigator}/>} aria-label="breadcrumb">
            {JSON.stringify(props.routes)}
            {breadcrumbs.map((bc: any) => (
             
                <NavLink to ={bc.match.path} style={{ fontSize: '.8em', color: '#fff', textDecoration: 'none' }} >  
                    {bc.breadcrumb}
                </NavLink>
            ))}
        </Breadcrumbs>
    ));

    return (
        <React.Fragment>
            <BreadcrumbLinks />
        </React.Fragment>
    );
}